import { FireCircleIcon } from './FireCircleIcon';

/**
 * author: Michael Irigoyen
 * id 942AE48C-F54D-4CD3-87A0-DC8DDDAD6F44
 * name fire-circle
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/fire-circle.svg
 * tags
 * - Home Automation 
 */
export const GasCircleIcon = FireCircleIcon;
export default GasCircleIcon